const setAccessToken = (token: string) => {
  const expirationDate = new Date()
  expirationDate.setDate(expirationDate.getDate() + 30)
  localStorage.setItem('accessToken', token)
}

export default setAccessToken
